module.exports = __webpack_public_path__ + "media/images/icons/arrow-left-university-a4c640a7c98ce3ec08de87f3a8b82d0f.svg";